import React, { FunctionComponent, useContext } from "react";
import { FormattedMessage } from "react-intl-phraseapp";
import { sendTealiumEvent } from "../../../helpers";
import { TealiumEventProps } from "../../../helpers/analytics";
import { linkToMedigapWaiverStateInfo } from "../../../helpers/CONSTANTS";
import { AppContext } from "../../../app/store";

const MedigapWaiverStateLinks: FunctionComponent<TealiumEventProps> = ({
  event_action,
  event_label,
}: TealiumEventProps) => {
  const {
    state: { language },
  } = useContext(AppContext);

  const waiverStateLink = (stateName: string): JSX.Element => (
    <a
      href={linkToMedigapWaiverStateInfo(language, stateName)}
      target="_blank"
      rel="noopener noreferrer"
      onClick={(): Promise<string> =>
        sendTealiumEvent(event_action, `${event_label}${stateName}`)
      }
    >
      {stateName}
    </a>
  );

  return (
    <FormattedMessage
      tagName="p"
      id="medigap.help.waiver_state_links"
      values={{
        maLink: waiverStateLink("Massachusetts"),
        miLink: waiverStateLink("Minnesota"),
        wiLink: waiverStateLink("Wisconsin"),
      }}
    />
  );
};

export default MedigapWaiverStateLinks;
